/**
* 触发时机，供Validation、Determination共用。
* @author wangjiegj<wangjiegj@inspur.com>
 */

/**
* 触发时机，供Validation、Determination共用。
*/
enum ExecutingDataStatus {
  /**
   * 不执行
   */
  None = 0,

  /**
   * 实例创建时执行
   */
  Created = 1,

  /**
   * 实例更新时执行
   */
  Updated = 2,

  /**
   * 实例删除时执行
   */
  Deleted = 4,

}

export { ExecutingDataStatus };
